import styled, { css } from 'styled-components';
import { QuicksandBold } from 'components/Text';
import Colors from 'constants/Colors';


export const Container = styled.div`
  background-color: ${Colors.SECONDARY};
  margin-top: 10px;
  margin-bottom: 10px;
  border: 2px solid ${Colors.SECONDARY};
  border-radius: 8px 8px 20px 20px;

 
`;
export const CardHeader = styled.div`
    padding:10px;
    margin: 0px 10px 0px 10px;
    display: flex;
    color:#FFF;
    justify-content: space-between;
    text-transform: uppercase;
    font-size: 16px;
    font-weight:${QuicksandBold};
    font-family:'Quicksand';
`;

export const CardContent = styled.div`
    background-color: #FFF;
    color: #000;
    padding: 20px;
    flex-grow: 1;
    border-radius: 0px 0px 20px 20px;
    ${(props) => props.isCollapse ? css`
    max-height: 0px;
    padding: 0px;
    transition: all .3s linear;
    overflow:hidden;
    ` : 
    css`
    max-height: auto;
    overflow:auto;
    padding: 20px;
    transition: all .4s linear;
    `};
`;

